import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Typography } from "@mui/material";
const StyledGridOverlay = styled('div')(({ theme })=>({
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        padding: theme.spacing(2)
    }));
export const NoRecords = ({ message, ...rest })=>{
    return /*#__PURE__*/ _jsx(StyledGridOverlay, {
        ...rest,
        "data-component": "noRecords",
        "data-testid": "noRecords",
        children: /*#__PURE__*/ _jsx(Typography, {
            component: "div",
            variant: "h6",
            children: message ?? 'No Records Found'
        })
    });
};
NoRecords.displayName = 'NoRecords';

//# sourceMappingURL=NoRecords.js.map